var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBtnFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.52,
    y1: 101.31,
    x2: 153.55,
    y2: -17.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3ac2d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#39c0d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#39bfd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#33aad7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2c93d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2781d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2477d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2374d7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESIGN_copy",
    "data-name": "DESIGN copy"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 194,
    height: 89,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.8,
    y: 6.02,
    width: 176.47,
    height: 71.56,
    rx: 8.49
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBtnFilter);
export default __webpack_public_path__ + "static/media/blueBtnFilter.33a883a4f9b751364a62379a449d7136.svg";
export { ForwardRef as ReactComponent };